/** URL canônica do site (deve coincidir com o Nginx: host acessado pelo público). */
export const CANONICAL_ORIGIN = 'http://162.141.110.70';
